'use strict';

var React = require('react');

var SvgResourcesMajor = function SvgResourcesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m19.986 10.835-.987-5.926a3.004 3.004 0 0 0-2.999-2.909 1 1 0 1 0 0 2c.552 0 1 .449 1 1 0 .055.005.11.014.165l.806 4.835h-5.82a1 1 0 0 0-1 1v.19a2.92 2.92 0 0 0-1-.19c-.35 0-.688.076-1 .19v-.19a1 1 0 0 0-1-1h-5.82l.806-4.835a.92.92 0 0 0 .014-.165c0-.551.449-1 1-1a1 1 0 0 0 0-2 3.004 3.004 0 0 0-2.999 2.909l-.988 5.926a2.29 2.29 0 0 0-.013.165v2.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-.039c.311-.234.714-.461 1-.461.286 0 .689.227 1 .461v.039c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-2.5c0-.029-.009-.136-.014-.165zm-12.986 2.665c0 1.379-1.122 2.5-2.5 2.5a2.503 2.503 0 0 1-2.5-2.5v-1.5h5v1.5zm11 0c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5v-1.5h5v1.5z"
  }));
};

exports.SvgResourcesMajor = SvgResourcesMajor;
